import {ImageBlock} from "@/lib/interfaces/blocks";
import {default as NextImage} from "next/image";
import SectionTitle from "@/components/SectionTitle";
import SectionContent from "@/components/SectionContent";

interface ImageProps {
    block: ImageBlock
}

export default function Image(props: ImageProps) {
    const image = props.block.medias.find(media => {
        return media.role === 'content_image';
    })
    if (image) {
        return (
            <section className="eo-section">
                <SectionTitle title={props.block.content.title} />
                <SectionContent>
                    <NextImage
                        className="team-logo"
                        priority
                        src={image.original_webp}
                        alt={props.block.content.title}
                        width={900}
                        height={900}
                    />
                </SectionContent>
            </section>
        )
    }
}